var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-list-item',{attrs:{"active-class":"primary white--text","link":"","to":"/dashboard"}},[_c('v-list-item-icon',{staticClass:"mr-4"},[_c('v-icon',[_vm._v("mdi-view-dashboard")])],1),_c('v-list-item-title',[_vm._v("Bảng thông tin chung")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }